import { useAppDispatch, useAppSelector } from "../redux-hook";
import {
	deleteSong,
	pushTopToWaitingList,
	pushToWaitingList,
	saveLastSong,
} from "./slice";
import type { SongWithSinger } from "shared-types/song";
import type { Song } from "src/@types/api-types";

export const usePlayerStateSelector = () =>
	useAppSelector((state) => state.player);

export const useCurrentSongSelector = () =>
	useAppSelector((state) => state.player.currentSong);

export const useWaitingListSelector = () =>
	useAppSelector((state) => state.player.waitingList);

export const useWaitingListScrollPositionSelector = () =>
	useAppSelector((state) => state.player.waitingListPosition);

export const useLastSongSelector = () =>
	useAppSelector((state) => state.player.lastSong);

export const useDisableFeatureSelector = () =>
	useAppSelector((state) => state.player.lastSong.disableFeatures);

export const useNextSongSelector = () =>
	useAppSelector((state) => {
		return state.player?.waitingList.length > 0
			? state.player?.waitingList[0]
			: null;
	});

export const useVolumeBarDisplaySelector = () =>
	useAppSelector((state) => {
		return state.player?.volume?.volumeBarDisplayed ?? false;
	});

export const useMutedVolumeSelector = () =>
	useAppSelector((state) => {
		return state.player?.volume?.muted ?? false;
	});

export const useIsWaitlingListSongDraggingSelector = () =>
	useAppSelector((state) => {
		return state.player?.isWaitlingListSongDragging;
	});

export const currentSongEndTimestampInSecondSelector = () =>
	useAppSelector((state) => {
		return state.player?.currentSongEndTimestampInSecond;
	});

export const useMusicPitchValueSelector = () =>
	useAppSelector((state) => {
		return state.player?.musicPitchValue;
	});

export const useAddToWaitingList = () => {
	const dispatch = useAppDispatch();
	return {
		addToWaitingList: (songs: SongWithSinger[]) => {
			dispatch(pushToWaitingList(songs));
		},
		addToWaitingListTop: (song: SongWithSinger) => {
			dispatch(pushTopToWaitingList(song));
		},
	};
};

export const useRemoveFromWaitingList = () => {
	const dispatch = useAppDispatch();
	return {
		removeFromWaitingList: (position: number) => {
			dispatch(deleteSong(position));
		},
	};
};

export const useSetLastSong = () => {
	const dispatch = useAppDispatch();
	return {
		setLastSong: (lastSong: Song | null) => {
			dispatch(saveLastSong(lastSong ?? null));
		},
	};
};
